import { InjectionKey, Ref } from "vue";

export const typeAheadContainerKey: InjectionKey<Ref<HTMLDivElement | null>> = Symbol();
